import { ColDef } from "ag-grid-community";

export const platformColumnDef: ColDef = {
  field: "resource.platform",
  headerName: "Platform",
};
